import { useSyncExternalStore } from 'react';

/**
 * True below Tailwind's `md` breakpoint (768px): the width at which the shell
 * swaps the sidebar for the bottom tab bar, dialogs become bottom sheets and
 * tables stack. One query, so every phone behaviour flips at the same width.
 * Styling alone should use `md:`/`max-md:` classes; this is for the few places
 * that render different markup.
 */
export const PHONE_QUERY = '(max-width: 767.98px)';

function subscribe(onChange: () => void): () => void {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {};
  const list = window.matchMedia(PHONE_QUERY);
  list.addEventListener('change', onChange);
  return () => list.removeEventListener('change', onChange);
}

function snapshot(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(PHONE_QUERY).matches
    : false;
}

export function useIsPhone(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => false);
}
